// @ts-nocheck
import React, {Component} from 'react';
import AddHCPP1 from './AddHCP_P1'
import AddHCPP2 from './AddHCP_P2'
import AddHCPP3 from './AddHCP_P3'
import AddHCPSuccess from './AddHcpSuccess'
import Popup from '../../../globalcomponents/Popup';



class AddHcp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 0,
            info: props.data || {},
            loaded: false
        };
    }

    componentDidMount() {
        this.setState({
            loaded: true
        })
    }

    nextPage(i, info) {
        if (info !== undefined) {
            let temp = this.state.info
            Object.assign(temp, info)
            this.setState({
                activePage: i,
                info: temp
            });
        }
        else {
            this.setState({
                activePage: i
            });
        }
    }

    render() {

        let page = [
            <AddHCPP1 user={this.props.user} info={this.state.info} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
            <AddHCPP2 user={this.props.user} info={this.state.info} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
            <AddHCPP3 user={this.props.user} info={this.state.info} type={this.state.type} submit={this.props.submit} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
            <AddHCPSuccess close={this.props.close} />,
        ]

        return (
            <div>
                {this.state.loaded > 0 ? <Popup component={page[this.state.activePage]} /> : ""}
            </div>
        )
    }
}

export default AddHcp;
